<template>
  <div>
    <header-component />
    <div
      :class="
        isAddPage ? 'px-2 pt-2 pb-2 w-full' : 'container-fluid pt-2'
      "
    >
      <form class="needs-validation" @submit.prevent="checkForm">
        <div class="card">
          <div class="card-header">
            <h3 class="mb-0" style="text-transform: capitalize">
              {{ isAddPage ? "Add Inquiry" : "Edit Inquiry" }}
            </h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button size="sm" type="primary" @click="openCustomerModal">
              New Customer
            </base-button>
            <base-button
              size="sm"
              type="default"
              :disabled="!canEditSelectedCustomer"
              @click="openEditCustomerModal"
            >
              Edit Customer
            </base-button>
            <base-button size="sm" type="primary" @click="refreshPage">
              Refresh
            </base-button>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <base-input label="Date">
                <el-date-picker
                  ref="date"
                  v-model="form.inquiryDate"
                  type="date"
                  style="width: 100%"
                />
              </base-input>
            </div>
            <div class="col-md-2">
              <base-input label="Customer By Name" tabindex="0">
                <el-select
                  clearable
                  ref="customerInput"
                  v-model="form.userId"
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'customer-name')
                  }"
                  filterable
                  remote
                  :remote-method="filterUserByName"
                  :loading="loading"
                  @change="getAddressesOnChangeOfCustomer"
                >
                  <div v-if="filteredUsers.length > 0">
                    <el-option
                      v-for="(item, index) in filteredUsers"
                      :key="index"
                      :value="item.userId"
                      :label="
                        item.firstName +
                          ' ' +
                          item.lastName +
                          ' (' +
                          item.phone +
                          ')'
                      "
                    />
                  </div>
                  <div
                    v-if="filteredUsers.length === 0 && searchedQuery.length > 0"
                  >
                    <el-option key="add-new" value="add-new" label="Add New" />
                  </div>
                </el-select>
              </base-input>
            </div>
            <div class="col-md-2">
              <base-input label="Customer By Phone" tabindex="0">
                <el-select
                  clearable
                  v-model="form.userId"
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'customer-name')
                  }"
                  filterable
                  remote
                  :remote-method="filterUserByPhone"
                  :loading="loading"
                  @change="getAddressesOnChangeOfCustomer"
                >
                  <div v-if="filteredUsers.length > 0">
                    <el-option
                      v-for="(item, index) in filteredUsers"
                      :key="index"
                      :value="item.userId"
                      :label="
                        item.firstName +
                          ' ' +
                          item.lastName +
                          ' (' +
                          item.phone +
                          ')'
                      "
                    />
                  </div>
                  <div
                    v-if="filteredUsers.length === 0 && searchedQuery.length > 0"
                  >
                    <el-option key="add-new" value="add-new" label="Add New" />
                  </div>
                </el-select>
              </base-input>
            </div>
            <div class="col-md-3" v-if="form.userId">
              <base-input label="Select Address" tabindex="0">
                <span v-if="showAddressLoader">
                  <i class="el-icon-loading" />
                  Loading Address...
                </span>
                <el-select
                  v-else
                  v-model="form.customerAddressId"
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'address')
                  }"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in customerAddresses"
                    :key="index"
                    :value="item.customerAddressId"
                    :label="item.address + ',(' + item.addressMarathi + ')'"
                  />
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <base-input label="Select Service" tabindex="3">
                <el-cascader
                  v-model="form.serviceJobsMeta"
                  :options="serviceOptions"
                  :props="{ multiple: true }"
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'service')
                  }"
                  filterable
                  clearable
                  style="width: 100%"
                >
                  <template slot-scope="{ node, data }">
                    <div v-if="data.value === 2">
                      <span>{{ data.label }}</span>
                    </div>
                    <div v-else-if="data.value === 3">
                      <span>{{ data.label }}</span>
                    </div>
                    <div v-else>
                      <span>{{ data.label }}</span>
                      <span v-if="!node.isLeaf">
                        ({{ data.children.length }})
                      </span>
                    </div>
                  </template>
                </el-cascader>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2" />
            <div class="col-md-3">
              <base-input label="Temporary Phone" tabindex="5">
                <el-input
                  v-uppercase
                  v-model="form.temporaryPhone"
                  type="text"
                />
              </base-input>
            </div>
            <div class="col-md-3">
              <base-input label="Description" tabindex="5">
                <el-input v-uppercase v-model="form.description" type="text" />
              </base-input>
            </div>
            <div class="col-md-3">
              <base-input label="Select Staff" tabindex="4">
                <el-select
                  v-model="form.assignedStaffUserId"
                  filterable
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'staff')
                  }"
                >
                  <el-option
                    v-for="(item, index) in staffList"
                    :key="index"
                    :value="item.userId"
                    :label="item.firstName + ' ' + item.lastName"
                  />
                </el-select>
              </base-input>
            </div>
          </div>

          <base-button
            :disabled="showLoader ? true : false"
            md
            type="primary"
            native-type="submit"
          >
            <span v-if="showLoader" class="btn-inner--icon">
              <i class="fas fa-spinner fa-spin" />
            </span>
            <span class="btn-inner--text">Save</span>
          </base-button>
        </div>
      </div>
    </form>
    <el-dialog
      :visible.sync="showCreateUserModal"
      title="Add User"
      width="60%"
      append-to-body
    >
      <create-user
        :redirect-to-users="false"
        :customer-type="true"
        :searchedField="searchedQuery"
        @close="closeUserModal"
      />
    </el-dialog>
    <el-dialog
      :visible.sync="showEditCustomerModal"
      title="Edit Customer"
      width="60%"
      append-to-body
      @closed="onEditCustomerModalClosed"
    >
      <create-user
        v-if="showEditCustomerModal"
        :redirect-to-users="false"
        :customer-type="true"
        @close="closeEditCustomerModal"
        @customer-updated="refreshSelectedCustomerData"
      />
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { Select, Option, DatePicker, Input, Dialog, Cascader } from "element-ui";
import { format } from "date-fns";
import { apiHelper } from "@/utils/helpers";
import endpoints from "@/utils/constants";
import HeaderComponent from "../Components/HeaderComponent";
import createUser from "../User/CreateUserComponent";

export default {
  name: "AddInquiry",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Input.name]: Input,
    [Dialog.name]: Dialog,
    [Cascader.name]: Cascader,
    "header-component": HeaderComponent,
    "create-user": createUser
  },
  directives: {
    uppercase: {
      inserted(el, _, vnode) {
        el.addEventListener("input", function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  props: {
    inquiryId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      searchedQuery: "",
      filteredUsers: [],
      loading: false,
      showCreateUserModal: false,
      showEditCustomerModal: false,
      formErrors: [],
      showLoader: false,
      customerAddresses: [],
      showAddressLoader: false,
      staffList: [],
      serviceOptions: [],
      form: {
        inquiryDate: new Date(),
        userId: null,
        customerAddressId: null,
        assignedStaffUserId: null,
        serviceJobsMeta: [],
        serviceId: null,
        description: "",
        temporaryPhone: ""
      }
    };
  },
  computed: {
    resolvedInquiryId() {
      return this.inquiryId || this.$route.params.id || null;
    },
    isAddPage() {
      return !this.resolvedInquiryId;
    },
    canEditSelectedCustomer() {
      const id = this.form.userId;
      return Boolean(id && this.isUUID(id));
    }
  },
  mounted() {
    this.loadStaff();
    this.loadServiceOptions();
    if (this.resolvedInquiryId) {
      this.showAddressLoader = true;
      this.loadInquiry();
    } else if (this.$refs.customerInput) {
      this.$refs.customerInput.$el.click();
    }
  },
  methods: {
    ...mapActions({
      getUsers: "user/getUsers",
      getCustomerAddresses: "user/getCustomerAddresses",
      searchUsers: "user/searchUsers",
      fetchUser: "user/fetchUser",
      saveInquiry: "inquiry/saveInquiry",
      updateInquiry: "inquiry/updateInquiry",
      fetchInquiry: "inquiry/fetchInquiry",
      getInquiryList: "inquiry/getInquiryList",
      getNestedServiceCategories: "serviceCategory/getNestedServiceCategories"
    }),
    ...mapMutations({
      resetUser: "user/resetUser",
      prefillUser: "user/prefillUser"
    }),

    loadStaff() {
      return apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}/api/v1/staff-users`)
        .then(res => {
          this.staffList = (res.data.users || []).map(row => {
            const parts = (row.name || "").trim().split(/\s+/);
            const firstName = parts[0] || "";
            const lastName = parts.slice(1).join(" ") || "";
            return {
              userId: row.user_id,
              firstName,
              lastName,
              phone: row.phone
            };
          });
        })
        .catch(() => {});
    },

    async loadServiceOptions() {
      try {
        this.serviceOptions = (await this.getNestedServiceCategories()) || [];
      } catch (e) {
        this.serviceOptions = [];
      }
    },

    resolveServiceIdFromSelection(serviceJobsMeta) {
      if (!Array.isArray(serviceJobsMeta) || serviceJobsMeta.length === 0) {
        return { error: "No Service Selected!" };
      }
      const partial = serviceJobsMeta.filter(
        path => Array.isArray(path) && path.length === 2
      );
      if (partial.length) {
        return { error: "Invalid services selected" };
      }
      const valid = serviceJobsMeta.filter(
        path =>
          Array.isArray(path) &&
          path.length === 3 &&
          this.isUUID(path[1]) &&
          this.isUUID(path[2])
      );
      if (!valid.length) {
        return { error: "No Service Selected!" };
      }
      if (valid.length > 1) {
        return {
          error: "Please select only one service for an inquiry."
        };
      }
      return { serviceId: valid[0][1] };
    },

    findServicePath(serviceId) {
      if (!serviceId || !this.serviceOptions.length) {
        return [];
      }
      for (const category of this.serviceOptions) {
        for (const service of category.children || []) {
          if (service.value === 2 || service.value !== serviceId) {
            continue;
          }
          const job = (service.children || []).find(
            child => child.value !== 3 && this.isUUID(child.value)
          );
          if (job) {
            return [category.value, service.value, job.value];
          }
        }
      }
      return [];
    },

    getAddressesOnChangeOfCustomer(userId) {
      if (userId) {
        const ifUUId = this.isUUID(userId);
        if (ifUUId) {
          this.form.customerAddressId = null;
          this.getCustomerAddresses(userId).then(res => {
            this.customerAddresses = res.data;
            if (
              this.form.customerAddressId === null &&
              this.customerAddresses.length
            ) {
              this.form.customerAddressId = this.customerAddresses[0].customerAddressId;
            }
          });
          this.showAddressLoader = false;
        } else if (/^\d+$/.test(this.searchedQuery)) {
          this.setPrimaryCustomerData({ phone: this.searchedQuery });
        } else {
          this.setPrimaryCustomerData({ name: this.searchedQuery });
        }
      }
    },

    isUUID(userId) {
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return uuidRegex.test(userId);
    },

    filterUserByName(query) {
      this.searchedQuery = query;
      if (query !== "") {
        this.loading = true;
        this.searchUsers({ name: query })
          .then(res => {
            this.filteredUsers = res;
            this.loading = false;
          })
          .catch(err => {
            if (err && err.status === 422) {
              this.filteredUsers = [];
            }
            this.loading = false;
          });
      } else {
        this.filteredUsers = [];
      }
    },

    filterUserByPhone(query) {
      this.searchedQuery = query;
      if (query !== "") {
        this.loading = true;
        this.searchUsers({ phone: query })
          .then(res => {
            this.filteredUsers = res;
            this.loading = false;
          })
          .catch(err => {
            if (err && err.status === 422) {
              this.filteredUsers = [];
            }
            this.loading = false;
          });
      } else {
        this.filteredUsers = [];
      }
    },

    openCustomerModal() {
      this.resetUser();
      this.showCreateUserModal = true;
    },

    async openEditCustomerModal() {
      if (!this.canEditSelectedCustomer) return;
      try {
        await this.fetchUser(this.form.userId);
        this.showEditCustomerModal = true;
      } catch (e) {
        this.$notify({
          message: "Could not load customer for editing",
          type: "danger",
          title: "Error"
        });
      }
    },

    closeEditCustomerModal() {
      this.showEditCustomerModal = false;
      this.getUsers({ role: "Customer", perPage: 1000 });
    },

    onEditCustomerModalClosed() {
      this.resetUser();
    },

    closeUserModal() {
      this.getUsers({ role: "Customer", perPage: 1000 });
      this.showCreateUserModal = false;
    },

    refreshSelectedCustomerData() {
      const uid = this.form.userId;
      if (!uid || !this.isUUID(uid)) return;
      const prevAddressId = this.form.customerAddressId;
      this.showAddressLoader = true;
      this.getUsers({ userId: uid })
        .then(data => {
          if (data && data.rows) {
            this.filteredUsers = data.rows;
          }
        })
        .catch(() => {});
      this.getCustomerAddresses(uid)
        .then(res => {
          this.customerAddresses = res.data || [];
          const stillHere = this.customerAddresses.some(
            a => a.customerAddressId === prevAddressId
          );
          if (stillHere) {
            this.form.customerAddressId = prevAddressId;
          } else if (this.customerAddresses.length) {
            this.form.customerAddressId = this.customerAddresses[0].customerAddressId;
          } else {
            this.form.customerAddressId = null;
          }
        })
        .finally(() => {
          this.showAddressLoader = false;
        });
    },

    setPrimaryCustomerData(data) {
      this.prefillUser(data);
      this.showCreateUserModal = true;
    },

    refreshPage() {
      this.loadStaff();
      this.loadServiceOptions();
    },

    loadInquiry() {
      this.fetchInquiry(this.resolvedInquiryId).then(async row => {
        this.form.inquiryDate = row.inquiryDate
          ? new Date(row.inquiryDate)
          : new Date();
        this.form.userId = row.userId;
        this.form.customerAddressId = row.customerAddressId;
        this.form.assignedStaffUserId = row.assignedStaffUserId;
        this.form.serviceId = row.serviceId || null;
        this.form.description = row.description || "";
        this.form.temporaryPhone = row.temporaryPhone || "";
        await this.loadServiceOptions();
        if (this.form.serviceId) {
          const path = this.findServicePath(this.form.serviceId);
          this.form.serviceJobsMeta = path.length ? [path] : [];
        }
        if (row.userId) {
          const parts = (row.customerName || "").trim().split(/\s+/);
          this.filteredUsers = [
            {
              userId: row.userId,
              firstName: parts[0] || "",
              lastName: parts.slice(1).join(" ") || "",
              phone: row.customerPhone
            }
          ];
          this.getCustomerAddresses(row.userId).then(res => {
            this.customerAddresses = res.data || [];
            this.showAddressLoader = false;
          });
        }
      });
    },

    checkForm() {
      this.formErrors = [];
      if (!this.form.inquiryDate) {
        this.formErrors.push({ field: "date", msg: "Date is required." });
      }
      if (!this.form.userId || !this.isUUID(this.form.userId)) {
        this.formErrors.push({
          field: "customer-name",
          msg: "Please select a customer."
        });
      }
      if (!this.form.assignedStaffUserId) {
        this.formErrors.push({
          field: "staff",
          msg: "Please select staff."
        });
      }
      const serviceResult = this.resolveServiceIdFromSelection(
        this.form.serviceJobsMeta
      );
      if (serviceResult.error) {
        this.formErrors.push({
          field: "service",
          msg: serviceResult.error
        });
      }
      if (this.formErrors.length) {
        this.formErrors.forEach(i => {
          this.$notify({
            message: i.msg,
            type: "danger",
            title: "Validation Error"
          });
        });
        return;
      }
      this.showLoader = true;
      this.submitInquiry();
    },

    submitInquiry() {
      const inquiryDate =
        this.form.inquiryDate instanceof Date
          ? format(this.form.inquiryDate, "YYYY-MM-DD")
          : this.form.inquiryDate;
      const serviceResult = this.resolveServiceIdFromSelection(
        this.form.serviceJobsMeta
      );
      const payload = {
        inquiryDate,
        userId: this.form.userId,
        customerAddressId: this.form.customerAddressId,
        assignedStaffUserId: this.form.assignedStaffUserId,
        serviceId: serviceResult.serviceId,
        description: this.form.description,
        temporaryPhone: this.form.temporaryPhone
      };
      const action = this.resolvedInquiryId
        ? this.updateInquiry({
            inquiryId: this.resolvedInquiryId,
            payload
          })
        : this.saveInquiry(payload);
      action
        .then(() => {
          this.$notify({
            message: this.resolvedInquiryId
              ? "Inquiry updated successfully."
              : "Inquiry created successfully.",
            type: "success",
            title: "Success"
          });
          this.getInquiryList();
          this.$router.push("/inquiries/list");
        })
        .catch(err => {
          const data = err.response && err.response.data;
          let msg = "Could not save inquiry.";
          if (data) {
            if (data.message) {
              msg = data.message;
            } else if (data.errors) {
              msg = Object.values(data.errors).flat().join(" ");
            }
          }
          this.$notify({ message: msg, type: "danger", title: "Error" });
        })
        .finally(() => {
          this.showLoader = false;
        });
    }
  }
};
</script>

<style>
.el-cascader-menu__wrap {
  height: 204px !important;
}

.el-cascader-node:not(.is-disabled):focus,
.el-cascader-node:not(.is-disabled):hover {
  background: #5e72e4;
  color: #ffffff;
}
</style>
